<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0,14C0,14,2,14,2,14C2,14,2,2,2,2C2,2,0,2,0,2C0,2,0,14,0,14C0,14,0,14,0,14ZM6,14C6,14,7,14,7,14C7,14,7,2,7,2C7,2,6,2,6,2C6,2,6,14,6,14C6,14,6,14,6,14ZM8,14C8,14,9,14,9,14C9,14,9,2,9,2C9,2,8,2,8,2C8,2,8,14,8,14C8,14,8,14,8,14ZM3,14C3,14,5,14,5,14C5,14,5,2,5,2C5,2,3,2,3,2C3,2,3,14,3,14C3,14,3,14,3,14ZM15,2C15,2,15,14,15,14C15,14,16,14,16,14C16,14,16,2,16,2C16,2,15,2,15,2C15,2,15,2,15,2ZM10,14C10,14,11,14,11,14C11,14,11,2,11,2C11,2,10,2,10,2C10,2,10,14,10,14C10,14,10,14,10,14ZM12,14C12,14,14,14,14,14C14,14,14,2,14,2C14,2,12,2,12,2C12,2,12,14,12,14C12,14,12,14,12,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Barcode',
} as DefineComponent
</script>
